export default "__VITE_ASSET__Dx9b21ja__"